import React from 'react';
import AIAgentCallMessageBox from './AIAgentCallMessageBox';
import AIAgentCallChatHeader from './AIAgentCallChatHeader';
import { twMerge } from 'tailwind-merge';
import AIAgentCallIntervention from '../AIAgentCallIntervention';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { CallSessionStatus } from 'utils';

type Props = {
  isIntervention: boolean;
};
const AIAgentCallChat: React.FC<Props> = ({ isIntervention }) => {
  const { callSession } = useAIAgentCenterContext();

  return (
    <div className='flex h-[calc(100vh-178px)] w-full flex-col'>
      <div>
        <AIAgentCallChatHeader />
      </div>
      <div
        className={twMerge(
          'flex flex-col bg-[#222A41] transition-all',
          isIntervention && callSession?.callStatus === CallSessionStatus.PROCESSING
            ? 'h-[calc(100vh-294px)]'
            : 'h-[calc(100vh-242px)]'
        )}
      >
        <AIAgentCallMessageBox />
      </div>
      {isIntervention && callSession?.callStatus === CallSessionStatus.PROCESSING && (
        <div className='flex h-13 w-full items-center justify-center'>
          <AIAgentCallIntervention callSessionId={callSession?.callSessionId} />
        </div>
      )}
    </div>
  );
};
export default AIAgentCallChat;
